module.exports = __webpack_public_path__ + "static/media/maanvi.ef2675c5.jpg";